import { render } from "./CarouselComp.vue?vue&type=template&id=4f3915f7"
import script from "./CarouselComp.vue?vue&type=script&lang=js"
export * from "./CarouselComp.vue?vue&type=script&lang=js"

import "./CarouselComp.vue?vue&type=style&index=0&id=4f3915f7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__